<header [@headerAnimation]="getState()?'show':'hide'" #header
    class="sticky top-0 z-1000 flex bg-lightCardBG dark:bg-darkCardBG border-b border-lightMode-300 dark:border-b dark:border-darkMode-700 transition-transform duration-300 ease-in-out"
    [class]="getState()?'':'-translate-y-full'">
    <div
        class="flex mx-auto 3xl:w-[1300px] 4xl:w-[1550px] w-full items-center justify-between">
        <div class="start-section flex items-center h-full">
            <div class="m-auto py-auto mr-3 lg:hidden">
                <button aria-label="sidebar-menu-button" mat-icon-button
                    class="flex items-center menu-icon justify-center lg:hidden rounded-full h-full "
                    (click)="sidenavService.changeSidebarState()">
                    <i
                        class="fas fa-bars text-lightMode-700 text-xl dark:text-darkMode-100 -mt-[2px] mx-auto"></i>
                </button>
            </div>
            <a routerLink (click)="scrollToViewNavigate()"
                class="py-1 px-3 w-full flex items-center">
                <img src="assets/image/roshdima.webp" alt="roshdima"
                    title="roshdima" class="h-12 aspect-square">
                <p
                    class="text-lightMode-700 dark:text-darkMode-100 mx-1 font-extrabold text-siteTitle">رشدیما</p>
            </a>
            <ul class="rtl:mr-3 ltr:ml-3 hidden lg:flex h-full">
                <li
                    class="mx-1 my-0 hover:bg-lightMode-300 dark:hover:bg-zinc-900 ease-in-out duration-100 h-full">
                    <button matRipple class="paddingZero h-full min-w-[65px]">
                        <a (click)="scrollToViewNavigate()"
                            [routerLink]="jwt.checkAuth()?['/feed']:['']"
                            routerLinkActive="text-lightPrimary dark:text-darkPrimary"
                            [routerLinkActiveOptions]="{exact:true}"
                            class="pt-2 pb-1 text-lightMode-700 cursor dark:text-darkMode-100 text-bold w-full h-full flex items-center justify-center flex-col"
                            style="display: flex; align-items: center;"
                            aria-label="destop-home-button">
                            <mat-icon fontIcon="home_app_logo"
                                class="notranslate material-symbols-outlined text-inherit text-[1.5rem] mat-center"></mat-icon>
                            <span
                                class="menu-item-text block text-[0.85rem] font-bold text-sm mx-auto">خانه</span>
                        </a>
                    </button>
                </li>
                <li *ngIf="jwt.checkAuth()"
                    class="mx-1 my-0 hover:bg-lightMode-300 dark:hover:bg-zinc-900 ease-in-out duration-100">
                    <button matRipple class="paddingZero min-w-[65px] h-full">
                        <a (click)="scrollToViewNavigate()"
                            [routerLink]="'/miz/kar'"
                            routerLinkActive="text-lightPrimary dark:text-darkPrimary"
                            class="w-full h-full pt-2 pb-1 text-lightMode-700 dark:text-darkMode-100 text-bold flex items-center justify-center flex-col"
                            style="display: flex; align-items: center;"
                            aria-label="destop-school-button">
                            <mat-icon fontIcon="airplay"
                                class="notranslate material-symbols-outlined text-inherit text-[1.5rem] mat-center"></mat-icon>
                            <span
                                class="menu-item-text block text-[0.85rem] font-bold text-sm mx-auto">میزکار</span>
                        </a>
                    </button>
                </li>
                <!-- && isAfarine() -->
                <li *ngIf="jwt.checkAuth() && isAfarine()"
                    class="mx-1 my-0 hover:bg-lightMode-300 dark:hover:bg-zinc-900 ease-in-out duration-100">
                    <button matRipple class="paddingZero min-w-[65px] h-full">
                        <a (click)="scrollToViewNavigate()"
                            routerLink="/miz/khedmat"
                            routerLinkActive="text-lightPrimary dark:text-darkPrimary"
                            class="w-full h-full pt-2 pb-1 text-lightMode-700 dark:text-darkMode-100 text-bold flex items-center justify-center flex-col"
                            style="display: flex; align-items: center;"
                            aria-label="destop-school-button">
                            <mat-icon fontIcon="service_toolbox"
                                class="notranslate material-symbols-outlined text-inherit text-[1.5rem] mat-center"></mat-icon>
                            <span
                                class="menu-item-text block text-[0.85rem] font-bold text-sm mx-auto">میزخدمت</span>
                        </a>
                    </button>
                </li>
                <li
                    class="mx-1 my-0 hover:bg-lightMode-300 dark:hover:bg-zinc-900 ease-in-out duration-100">
                    <button matRipple class="paddingZero h-full min-w-[65px]">
                        <a (click)="scrollToViewNavigate()" routerLink="/abzar"
                            routerLinkActive="text-lightPrimary dark:text-darkPrimary"
                            class="w-full h-full pt-2 pb-1 text-lightMode-700 dark:text-darkMode-100 text-bold flex items-center justify-center flex-col"
                            style="display: flex; align-items: center;"
                            aria-label="destop-school-button">
                            <mat-icon fontIcon="design_services"
                                class="notranslate material-symbols-outlined text-inherit text-[1.5rem] mat-center"></mat-icon>
                            <span
                                class="menu-item-text block text-[0.85rem] font-bold text-sm mx-auto">ابزارها</span>
                        </a>
                    </button>
                </li>
                <!-- <li class="mx-1 my-0 hover:bg-lightMode-300 dark:hover:bg-zinc-900 ease-in-out duration-100">
                    <button matRipple class="paddingZero h-full">
                        <a (click)="scrollToViewNavigate()" routerLink="/nahad" routerLinkActive="text-lightPrimary dark:text-darkPrimary" class="w-full h-full pt-2 pb-1 px-4 text-lightMode-700 cursor dark:text-darkMode-100 text-bold flex items-center justify-center flex-col" style="display: flex; align-items: center;" aria-label="destop-library-button">
                            <mat-icon fontIcon="corporate_fare" class="notranslate material-symbols-outlined text-inherit text-[1.5rem] mat-center"></mat-icon>
                            <span class="menu-item-text block text-[0.85rem] font-bold text-sm mx-auto">سازمانها</span>
                        </a>
                    </button>
                </li> -->
                <!-- <li class="mx-1 my-0 hover:bg-lightMode-300 dark:hover:bg-zinc-900 ease-in-out duration-100">
                    <button matRipple class="paddingZero h-full">
                        <a (click)="scrollToViewNavigate()" routerLink="/hamafarin" routerLinkActive="text-lightPrimary dark:text-darkPrimary" class="w-full h-full pt-2 pb-1 px-4 text-lightMode-700 cursor dark:text-darkMode-100 text-bold flex items-center justify-center flex-col" style="display: flex; align-items: center;" aria-label="destop-library-button">
                            <mat-icon fontIcon="group" class="notranslate material-symbols-outlined text-inherit text-[1.5rem] mat-center"></mat-icon>
                            <span class="menu-item-text block text-[0.85rem] font-bold text-sm mx-auto">افراد</span>
                        </a>
                    </button>
                </li> -->
                <li
                    class="mx-1 my-0 hover:bg-lightMode-300 dark:hover:bg-zinc-900 ease-in-out duration-100">
                    <button matRipple class="paddingZero h-full min-w-[65px]">
                        <a (click)="scrollToViewNavigate()"
                            [routerLink]="katibePathProduction()"
                            routerLinkActive="text-lightPrimary dark:text-darkPrimary"
                            class="w-full h-full pt-2 pb-1 text-lightMode-700 cursor dark:text-darkMode-100 text-bold flex items-center justify-center flex-col"
                            style="display: flex; align-items: center;"
                            aria-label="destop-library-button">
                            <mat-icon fontIcon="auto_stories"
                                class="notranslate material-symbols-outlined text-inherit text-[1.5rem] mat-center"></mat-icon>
                            <span
                                class="menu-item-text block text-[0.85rem] font-bold text-sm mx-auto">کتیبه</span>
                        </a>
                    </button>
                </li>
            </ul>
        </div>
        <div class="end-section flex items-center rtl:pr-5 ltr:pl-5 gap-2.5">
            <button (click)="setTheme()" mat-icon-button type="button"
                class="col-1 flex items-center justify-center mode mat-icon-button matRipple-base"
                title="Switch to dark mode" aria-label="switch-to-dark-mode">
                <div class="matRipple-wrapper flex items-center justify-center">
                    <i
                        class="fas fa-sun notranslate  text-darkMode-100 text-[1.25rem] mat-icon-no-color"
                        *ngIf="isDark==true"></i>
                    <i
                        class="fas fa-moon notranslate text-lightMode-700 text-[1.25rem]  mat-icon-no-color"
                        *ngIf="isDark==false"></i>
                </div>
            </button>
            <!-- <app-notification *ngIf="global.jwtService.checkAuth()"></app-notification> -->
            <app-entity-header-option></app-entity-header-option>
        </div>
    </div>
</header>
<div @fadeAnimation
    class="bg-darkBG opacity-50 fixed top-0 left-0 z-[100] w-screen h-screen"
    *ngIf="!getState()" (click)="changeState()"></div>
<app-sidenavbar *ngIf="!getState()" @sideNavAnimation
    class="fixed top-0 right-0 z-[200]"></app-sidenavbar>